import { SharedModule } from './../shared/shared.module';
import { NgModule } from '@angular/core';
import { CodeSetEditComponent } from './codeset-edit/codeset-edit.component';
import { CodesetLanguageEditComponent } from './codeset-language-edit/codeset-language-edit.component';

@NgModule({
  declarations: [
    CodeSetEditComponent,
    CodesetLanguageEditComponent
  ],
  imports: [
    SharedModule
  ]
})
export class CodesetModule { }
